export default {
  listagem: {
    titulo_pagina: "Contenedores de Control Desechables",
    table: {
      empty: "No se encontró ningún Vns",
      nome: "Vns",
      empresa: "Empresa",
      resultado_descartavel: "Contenedor de Control Desechable",
      editar: "Editar"
    }
  },
  form: {
    titulo_pagina: {
      editar: "Editar Contenedores de Control Desechables"
    },
    fields: {
      vns: {
        label: "Vns",
        description: "Nombre del Vns"
      },
      report_control: {
        label: "Contenedores de Control Desechables",
        description: "Contenedores de control que serán desechados por Vns"
      },
      botao_salvar: "Guardar Contenedores de Control Desechables"
    },
    update: {
      success: "¡Contenedores de control desechables actualizados con éxito!",
      error: "¡Error al actualizar los resultados de control desechables!"
    }
  }
}
